export { default as Img200 } from './processed/200/PrinceOfPersia_xbox_lrg.jpg';
export { default as Img400 } from './processed/400/PrinceOfPersia_xbox_lrg.jpg';
export { default as Imgthumb } from './processed/thumb/PrinceOfPersia_xbox_lrg.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/PrinceOfPersia_xbox_lrg.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/PrinceOfPersia_xbox_lrg.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      189,
      118,
      68
    ],
    "_population": 639,
    "_hsl": [
      0.06887052341597796,
      0.4782608695652174,
      0.503921568627451
    ]
  },
  "LightVibrant": {
    "_rgb": [
      212,
      169,
      131
    ],
    "_population": 613,
    "_hsl": [
      0.07818930041152262,
      0.4850299401197607,
      0.6725490196078432
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      104,
      28,
      20
    ],
    "_population": 2,
    "_hsl": [
      0.015873015873015872,
      0.6774193548387096,
      0.24313725490196078
    ]
  },
  "Muted": {
    "_rgb": [
      157,
      134,
      100
    ],
    "_population": 279,
    "_hsl": [
      0.09941520467836257,
      0.22529644268774707,
      0.503921568627451
    ]
  },
  "LightMuted": {
    "_rgb": [
      201,
      197,
      187
    ],
    "_population": 2071,
    "_hsl": [
      0.11904761904761924,
      0.11475409836065575,
      0.7607843137254902
    ]
  },
  "DarkMuted": {
    "_rgb": [
      63,
      45,
      32
    ],
    "_population": 2045,
    "_hsl": [
      0.06989247311827958,
      0.3263157894736842,
      0.18627450980392157
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/PrinceOfPersia_xbox_lrg.js